interface IsAccommodationV2BookingParams {
  property: Pick<App.Property.Property, 'accommV2Bookable'>
  isLoggedIn: boolean
}

/**
 * Single gate for the accommodationV2 SPP checkout path.
 *
 * Both of the following must be true:
 * - property.accommV2Bookable (svc-accommodation content)
 * - customer is logged in (enquiry-session create requires auth)
 *
 * When false, callers must fall through to the legacy hotel / bedbankHotel path.
 */
export function isAccommodationV2Booking({
  property,
  isLoggedIn,
}: IsAccommodationV2BookingParams): boolean {
  return !!property.accommV2Bookable && isLoggedIn
}
